/* eslint quotes:0 */
'use strict';

// top part
function generateTop(ctx, t, colors) {
  // bar
  ctx.fillStyle = colors.yellow;
  ctx.fillRect(0, 0, 210 * t, 21 * t);

  // boxes
  ctx.fillStyle = colors.white;
  // field "Total sum" in first block
  ctx.fillRect(79 * t, 11 * t, 37 * t, 8 * t);
  // field "Betalerens kontonumer" in first block
  ctx.fillRect(126 * t, 11 * t, 41 * t, 8 * t);
  // field "Blankettnummer" in first block
  ctx.fillRect(170 * t, 11 * t, 30 * t, 8 * t);

  // text
  ctx.fillStyle = colors.black;
  ctx.font = 4 * t + 'px Arial';
  // Kvittering
  ctx.fillText('Kvittering', 15 * t, 5 * t);

  ctx.font = 3 * t + 'px Arial';
  // Innbetalt til konto
  ctx.fillText('Innbetalt til konto', 15 * t, 11 * t);
  // Beløp
  ctx.fillText('Bel\u00F8p', 82 * t, 9 * t);
  // Betalerens kontonummer
  ctx.fillText('Betalerens kontonummer', 129 * t, 9 * t);
  // Blankettnummer (pa kvitteringsdelen)
  ctx.fillText('Blankettnummer', 172 * t, 9 * t);
}

// middle
function generateMiddle(ctx, t, colors) {
  // draw some yellow lines
  ctx.strokeStyle = colors.yellow;
  // yellow line inside "Underskrift ved girering"
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(119 * t, 47 * t);
  ctx.lineTo(190 * t, 47 * t);
  ctx.stroke();

  ctx.strokeStyle = colors.grey;
  // "corners" around "Betalt av"
  ctx.beginPath();
  ctx.moveTo(12 * t, 57 * t);
  ctx.lineTo(14 * t, 57 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(96 * t, 57 * t);
  ctx.lineTo(98 * t, 57 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(98 * t, 57 * t);
  ctx.lineTo(98 * t, 59 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(98 * t, 77 * t);
  ctx.lineTo(98 * t, 79 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(96 * t, 79 * t);
  ctx.lineTo(98 * t, 79 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(12 * t, 79 * t);
  ctx.lineTo(14 * t, 79 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(12 * t, 77 * t);
  ctx.lineTo(12 * t, 79 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(12 * t, 57 * t);
  ctx.lineTo(12 * t, 59 * t);
  ctx.stroke();

  // "corners" around "Betalt til"
  ctx.beginPath();
  ctx.moveTo(111 * t, 57 * t);
  ctx.lineTo(113 * t, 57 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(196 * t, 57 * t);
  ctx.lineTo(198 * t, 57 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(198 * t, 57 * t);
  ctx.lineTo(198 * t, 59 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(198 * t, 77 * t);
  ctx.lineTo(198 * t, 79 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(196 * t, 79 * t);
  ctx.lineTo(198 * t, 79 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(111 * t, 79 * t);
  ctx.lineTo(113 * t, 79 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(111 * t, 77 * t);
  ctx.lineTo(111 * t, 79 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(111 * t, 57 * t);
  ctx.lineTo(111 * t, 59 * t);
  ctx.stroke();

  // "corners" around "Underskrift ved girering"
  ctx.beginPath();
  ctx.moveTo(111 * t, 33 * t);
  ctx.lineTo(113 * t, 33 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(196 * t, 33 * t);
  ctx.lineTo(198 * t, 33 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(198 * t, 33 * t);
  ctx.lineTo(198 * t, 35 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(198 * t, 51 * t);
  ctx.lineTo(198 * t, 53 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(196 * t, 53 * t);
  ctx.lineTo(198 * t, 53 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(111 * t, 53 * t);
  ctx.lineTo(113 * t, 53 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(111 * t, 51 * t);
  ctx.lineTo(111 * t, 53 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(111 * t, 33 * t);
  ctx.lineTo(111 * t, 35 * t);
  ctx.stroke();

  // "corners" around "Betalingsfrist"
  ctx.beginPath();
  ctx.moveTo(167 * t, 23 * t);
  ctx.lineTo(169 * t, 23 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(196 * t, 23 * t);
  ctx.lineTo(198 * t, 23 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(198 * t, 23 * t);
  ctx.lineTo(198 * t, 25 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(198 * t, 28 * t);
  ctx.lineTo(198 * t, 30 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(196 * t, 30 * t);
  ctx.lineTo(198 * t, 30 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(169 * t, 30 * t);
  ctx.lineTo(167 * t, 30 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(167 * t, 28 * t);
  ctx.lineTo(167 * t, 30 * t);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(167 * t, 23 * t);
  ctx.lineTo(167 * t, 25 * t);
  ctx.stroke();

  // text
  ctx.fillStyle = colors.black;
  ctx.font = 'bold ' + 4 * t + 'px Arial';
  // GIRO
  ctx.fillText('GIRO', 111 * t, 26 * t);

  ctx.font = 'bold ' + 3 * t + 'px Arial';
  // Betalingsinformasjon
  ctx.fillText('Betalingsinformasjon', 15 * t, 25 * t);
  // Betalt av
  ctx.fillText('Betalt av', 15 * t, 56 * t);
  // Betalt til
  ctx.fillText('Betalt til', 114 * t, 56 * t);
  // Underskrift ved girering
  ctx.fillText('Underskrift ved girering', 114 * t, 32 * t);
  // Betalingsfrist 1
  ctx.fillText('Betalings-', 151 * t, 26 * t);
  // Betalingsfrist 2
  ctx.fillText('frist', 151 * t, 29 * t);

  // Red text on Underskrift
  // ctx.fillStyle = colors.red;
  // ctx.font = 'normal ' + 3 * t + 'px Arial';
  // ctx.fillText('NB: denne utskriften kan ikke brukes i brevgiro.', 123 * t, 46 * t);
}

// bottom
function generateBottom(ctx, t, colors) {
  // bar
  ctx.fillStyle = colors.yellow;
  ctx.fillRect(0, 80 * t, 210 * t, 8 * t);
  ctx.fillRect(0, 105 * t, 210 * t, 2 * t);

  // boxes
  ctx.fillStyle = colors.white;
  // white rectangle after "Belast konto"
  ctx.fillRect(43 * t, 81 * t, 5 * t, 6 * t);
  // white rectangle after "Belast konto"
  ctx.fillRect(49 * t, 81 * t, 5 * t, 6 * t);
  // white rectangle after "Belast konto"
  ctx.fillRect(55 * t, 81 * t, 5 * t, 6 * t);
  // white rectangle after "Belast konto"
  ctx.fillRect(61 * t, 81 * t, 5 * t, 6 * t);
  // white rectangle after "Belast konto"
  ctx.fillRect(67 * t, 81 * t, 5 * t, 6 * t);
  // white rectangle after "Belast konto"
  ctx.fillRect(73 * t, 81 * t, 5 * t, 6 * t);
  // white rectangle after "Belast konto"
  ctx.fillRect(79 * t, 81 * t, 5 * t, 6 * t);
  // white rectangle after "Belast konto"
  ctx.fillRect(85 * t, 81 * t, 5 * t, 6 * t);
  // white rectangle after "Belast konto"
  ctx.fillRect(91 * t, 81 * t, 5 * t, 6 * t);
  // white rectangle after "Belast konto"
  ctx.fillRect(97 * t, 81 * t, 5 * t, 6 * t);
  // white rectangle after "Belast konto"
  ctx.fillRect(103 * t, 81 * t, 5 * t, 6 * t);
  // white rectangle after "Kvittering tilbake"
  ctx.fillRect(192 * t, 81 * t, 5 * t, 6 * t);

  ctx.lineWidth = 2;
  ctx.lineHeight = 2;

  // vertical line before "KID"
  ctx.strokeStyle = colors.grey;
  ctx.beginPath();
  ctx.moveTo(8 * t, 90 * t);
  ctx.lineTo(8 * t, 105 * t);
  ctx.stroke();

  // vertical line before "Kroner"
  ctx.strokeStyle = colors.grey;
  ctx.beginPath();
  ctx.moveTo(79 * t, 90 * t);
  ctx.lineTo(79 * t, 105 * t);
  ctx.stroke();

  // vertical yellow line seperating sum
  ctx.strokeStyle = colors.yellow;
  ctx.beginPath();
  ctx.moveTo(104 * t, 90 * t);
  ctx.lineTo(104 * t, 105 * t);
  ctx.stroke();

  ctx.fillStyle = colors.black;
  ctx.font = 3 * t + 'px Arial';
  // H before KID
  ctx.fillText('H', 2 * t, 101 * t);
  // KID
  ctx.fillText('Kundeidentifikasjon (KID)', 10 * t, 92 * t);
  // Kroner
  ctx.fillText('Kroner', 81 * t, 92 * t);
  // Øre
  ctx.fillText('\u00D8re', 106 * t, 92 * t);
  // Til konto
  ctx.fillText('Til konto', 132 * t, 92 * t);
  // Blankettnummer (på betalingsdelen)
  ctx.fillText('Blankettnummer', 172 * t, 92 * t);
  // Belast konto 1
  ctx.fillText('Belast', 31 * t, 84 * t);
  // Belast konto 2
  ctx.fillText('konto', 31 * t, 87 * t);
  // Kvittering tilbake 1
  ctx.fillText('Kvittering', 178 * t, 84 * t);
  // Kvittering tilbake 2
  ctx.fillText('tilbake', 178 * t, 87 * t);

  ctx.font = 3 * t + 'px Courier New';
  // <
  ctx.fillText('<', 114 * t, 101 * t);
  // >
  ctx.fillText('>', 124 * t, 101 * t);
}

// dynamic values
function generateValues(ctx, t, colors, data, type) {
  const number = 5079862697;

  ctx.fillStyle = colors.black;
  ctx.font = 4 * t + 'px Courier New';
  // beløp
  let total = (data.total.toFixed(2) + '').replace('.', ',');
  ctx.fillText(total, (115 - total.length * 2.5) * t, 17 * t);
  // blanketnummer
  ctx.fillText(number, 173 * t, 17 * t);

  ctx.font = 3 * t + 'px Arial';
  // Betalingsinformasjon
  if (type === 'creditNote') {
    ctx.fillText('Kreditnota: ' + data.invoiceNumber, 15 * t, 30 * t);
  } else {
    ctx.fillText('Fakturanummer: ' + data.invoiceNumber, 15 * t, 30 * t);
  }
  ctx.fillText('Fakturadato: ' + data.invoiceDate, 15 * t, 35 * t);

  ctx.font = 4 * t + 'px Arial';
  // betalerens kontonummer
  ctx.fillText((data.accountNumber + '').replace(/(.{4})/, "$1.").replace(/(.{7})/, "$1."), 15 * t, 17 * t);
  // Betalingsfrist
  ctx.fillText(data.dueDate, 175 * t, 28 * t);

  // Betalt av
  if (data.recipient) {
    ctx.font = 'bold ' + 3 * t + 'px Arial';
    ctx.fillText(data.recipient.name, 15 * t, 61 * t);
    ctx.font = 3 * t + 'px Arial';
    ctx.fillText(data.recipient.address1, 15 * t, 65 * t);
    ctx.fillText(data.recipient.address2, 15 * t, 69 * t);
    ctx.fillText(data.recipient.zipCity, 15 * t, 73 * t);
    ctx.fillText(data.recipient.country, 15 * t, 77 * t);
  }

  // Betalt til
  if (data.originator) {
    ctx.font = 'bold ' + 3 * t + 'px Arial';
    ctx.fillText(data.originator.name, 114 * t, 61 * t);
    ctx.font = 3 * t + 'px Arial';
    ctx.fillText(data.originator.address1, 114 * t, 65 * t);
    ctx.fillText(data.originator.address2, 114 * t, 69 * t);
    ctx.fillText(data.originator.zipCity, 114 * t, 73 * t);
    ctx.fillText(data.originator.country, 114 * t, 77 * t);

    if (data.originator.kid) {
      ctx.fillText('KID genereres n\u00E5r regningen sendes', 10 * t, 101 * t);
    }
  }

  ctx.font = 3 * t + 'px Arial';

  // KID
  if (data.kid) {
    ctx.fillText(data.kid, 10 * t, 101 * t);
  }

  // kroner
  let crowns = (data.total + '').split('.')[0];
  ctx.fillText(crowns, (102 - crowns.length * 2) * t, 101 * t);
  // øre
  ctx.fillText((data.total.toFixed(2) + '').split('.')[1] || '00', 106 * t, 101 * t);
  // Til konto
  ctx.fillText((data.accountNumber + '').replace(/(.{4})/, "$1.").replace(/(.{7})/, "$1."), 132 * t, 101 * t);

  ctx.font = 3 * t + 'px Courier New';
  // Blankettnummer (på betalingsdelen)
  ctx.fillText('<' + number + '>', 172 * t, 101 * t);
}

function generate(id, size, data, type) {
  // mm --> px = mm*4
  let times = size || 4;

  let container = document.getElementById(id);
  let canvas = document.createElement('canvas');
  container.appendChild(canvas);
  canvas.height = 110 * times;
  canvas.width = 210 * times;
  let ctx = canvas.getContext('2d');

  const colors = {
    yellow: '#fdff73',
    white: '#fff',
    black: '#000',
    darkGrey: '#424242',
    grey: '#ddd',
    red: '#b55757'
  };

  // set the full bg to white
  ctx.fillStyle = colors.white;
  ctx.fillRect(0, 0, 210 * times, 110 * times);

  generateTop(ctx, times, colors);
  generateMiddle(ctx, times, colors);
  generateBottom(ctx, times, colors);
  generateValues(ctx, times, colors, data, type);
}

function giro() {
  return {
    restrict: 'E',
    scope: {
      data: '='
    },
    template: '<div id="canvas-giro" style="margin-top: 25px;"></div>',
    replace: true,
    link: ($scope, $element, $attrs) => {
      $scope.type = $attrs.type || 'invoice';
      $scope.data = $scope.data || {
        invoiceNumber: '---',
        invoiceDate: moment().format('DD.MM.YY'),
        total: 0,
        accountNumber: '',
        dueDate: moment().add(14, 'days').format('DD.MM.YY'),
        kid: '',
        recipient: {
          name: '',
          address1: '',
          address2: '',
          zipCity: '',
          country: ''
        },
        originator: {
          name: '',
          address1: '',
          address2: '',
          zipCity: '',
          country: ''
        }
      };

      $scope.$watch('data', (val, old) => {
        if (val !== old) {
          $element.empty();
          generate('canvas-giro', 5.12, val, $scope.type);
        }
      }, true);
    }
  };
}

angular
  .module('sr.giro', [])
  .directive('giro', giro);
